import { Country, RoleName } from '../../types'

export const isHRAdminOfThisCountry = (country: Country, roleNames: RoleName[]): boolean => {
  const hrAdminRoles = roleNames.filter((rn) => rn.includes('HR_ADMIN'))
  const hrAdminForThisCountry = hrAdminRoles.find((rn) => {
    const rnCountry = rn.split('_')[2] as Country
    return country === rnCountry
  })
  return !!hrAdminForThisCountry
}

export const getCountriesWhereUserIsHrAdmin = (roleNames: RoleName[]): Country[] => {
  const hrRoles = roleNames.filter((rn) => rn.includes('HR_ADMIN'))
  const countries = hrRoles.map((rn) => rn.split('_')[2] as Country)
  return [...new Set(countries)]
}

export const getCountriesWhereUserIsHr = (roleNames: RoleName[]): Country[] => {
  const hrRoles = roleNames.filter((rn) => rn.includes('HR_'))
  const countries = hrRoles.map((rn) => rn.split('_')[2] as Country)
  return [...new Set(countries)]
}
